import { Component, Input } from '@angular/core';
import { BtQRCodeModel } from '../bt-qrcode.model';

@Component({
    selector: 'bt-qrcode-design',
    templateUrl: './bt-qrcode-design.component.html',
    styleUrls: ['./bt-qrcode-design.component.scss']
})
export class BtQRCodeDesignComponent {
    @Input() model: BtQRCodeModel;
    @Input() value: any;
}